import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LearnsetsViewComponent } from "./learnsets-view.component";
import { SharedModule } from "src/app/shared/shared.module";
import { ControlsModule } from "src/app/controls/controls.module";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [
    LearnsetsViewComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ControlsModule,
    SharedModule
  ],
  exports: [
    LearnsetsViewComponent
  ]
})
export class LearnsetsViewModule { }